module.exports = __webpack_public_path__ + "media/components/home/creator-community/img/raymond-pettit-avatar-a08b298206b1f71209166a7791597a09.jpg";